// extracted by mini-css-extract-plugin
module.exports = {"teamCard__title":"TeamCard_teamCard__title_1la6x","teamCard__location":"TeamCard_teamCard__location_3m8eB"};